import { Navigate, useLocation } from "react-router-dom";
import { useRef, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "@redux/hooks";
import { notifyUser } from "@redux/slices/CommonSlice";
import { PAGE_URLS } from "constants/common";
import { selectCorporateSelectionRequired } from "@redux/slices/AuthSlice";

type Props = { children: React.ReactNode };

const RequireCorporateGuard = ({ children }: Props) => {
  const location = useLocation();
  const dispatch = useAppDispatch();
  const notifiedRef = useRef(false);
  const is_corporate_selection_required = useAppSelector(
    selectCorporateSelectionRequired,
  );
  const hasSelection = !!localStorage.getItem("selected_corporate");

  useEffect(() => {
    if (
      is_corporate_selection_required &&
      !hasSelection &&
      !notifiedRef.current
    ) {
      dispatch(
        notifyUser({
          title: "Please select a corporate to proceed.",
          message: "",
        }),
      );
      notifiedRef.current = true;
    }
  }, [hasSelection, dispatch, is_corporate_selection_required]);
  if (is_corporate_selection_required && !hasSelection) {
    localStorage.removeItem("selected_corporate"); // <-- Remove before redirect
    return (
      <Navigate
        to={PAGE_URLS.SELECT_CORPORATE}
        replace
        state={{ redirect_url: location.pathname + location.search }}
      />
    );
  }

  return <>{children}</>;
};

export default RequireCorporateGuard;
